// @ts-ignore
define("SDB.FindPerfectFit.Search.View", [
  "SDB.FindPerfectFit.Model",
  "sdb_find_perfect_fit_search.tpl",
  "SCView",
  "jQuery",
  "AjaxRequestsKiller",
  "Configuration",
  "Utils",
], function (
  SDBFindPerfectFitModel,
  sdb_find_perfect_fit_search_tpl,
  SCViewComponent,
  $,
  AjaxRequestsKiller,
  Configuration,
  Utils
) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function SDBFindPerfectFitSearchView(options) {
    SCView.call(this);
    var self = this;
    this.template = sdb_find_perfect_fit_search_tpl;
    this.options = options || {};
    this.model = options.model
      ? options.model
      : SDBFindPerfectFitModel.getInstance();
    this.env = options.container.getComponent("Environment");
    this.attributes = {
      id: "SDBFindPerfectFitSearchViewId",
      class: "sdb-find-perfect-fit-search-view",
    };
    var category = this.model.get("category").name;
    if (category !== "Wheels" && category !== "Tires") {
      SC.loadingIndicatorHide();
      return;
    }
    this.model.set("selections", []);
    var currentStep = this.model.set("step", 0);
    var initialOptions = self.getOptions();
    var nextFacetColumn = initialOptions[1].facet;
    // this.model.set("nextValue", self.getListValues(category, initialOptions[0], nextFacetColumn, true, true));
    this.model.unset("categoryOptions");
    // SC.loadingIndicatorShow();

    this.getCurrentStep = function (facet, options) {
      for (var i = 0; i < options.length; i++) {
        if (options[i].facet === facet) {
          return i + 1; // Steps are 1-indexed
        }
      }
    };

    this.changeOptionHandler = function changeOptionHandler(e) {
      var $target = this.$(e.target).closest("select");
      var facet = $target.attr("data-facet");
      var value = $target[0].selectedIndex !== 0 ? $target.val() : null;
      var optionId = $target
        .find("option")
        .eq($target.prop("selectedIndex"))
        .attr("id");
      var category = this.model.get("category").name;
      var fieldStep = self.getCurrentStep(facet, this.options);
      var $nextSelect = $target.next("select");

      //remove selection when empty value is selected
      if (!value || value === "- None -") {
        this.disableNextValues($nextSelect);
        this.model.set("step", fieldStep);
        var btn = this.$(e.target).parent().find("button");
        if (btn) {
          btn.get(0).disabled = true;
        }
        return;
      }

      // Find the existing selection object for the specified facet
      var existingSelection = this.model
        .get("selections")
        .find(function (selection) {
          return selection.facet === facet;
        });

      // Update the value and ID of the existing selection object
      if (existingSelection) {
        existingSelection.value = value;
        existingSelection.id = optionId;

        var objIndex = _.findIndex(
          this.model.get("selections"),
          existingSelection
        );
        this.model.get("selections").splice(objIndex + 1, this.options.length);
      } else {
        // Create a new selection object if it doesn't exist
        var currentSelection = {
          facet: facet,
          value: value,
          id: optionId,
        };
        this.model.get("selections").push(currentSelection);
      }
      // Update the selections in the model
      this.model.set("selections", this.model.get("selections"));

      if ($nextSelect.length) {
        var currentSelection = this.model.get("selections");
        var nextFacet = $nextSelect.attr("data-facet");
        nextFacet = nextFacet.trim();
        this.getListValues(category, currentSelection, nextFacet, true).catch(
          function (error) {
            console.error("Error getting list values", error);
          }
        );
        this.model.set("step", fieldStep);

        $nextSelect[0].disabled = false;
        $nextSelect[0].focus();

        $nextSelect = $nextSelect.next("select");
        this.disableNextValues($nextSelect);
      } else {
        var btn = this.$(e.target).next("button");
        if (btn) {
          btn.get(0).disabled = false;
        }
      }
    };

    this.disableNextValues = function disableNextValues($nextSelect) {
      while ($nextSelect.length) {
        $nextSelect[0].selectedIndex = 0;
        $nextSelect[0].disabled = true;
        var facet = $nextSelect.attr("data-facet");

        var existingSelection = this.model
          .get("selections")
          .find(function (selection) {
            return selection.facet === facet;
          });
        var objIndex = _.findIndex(
          this.model.get("selections"),
          existingSelection
        );
        this.model.get("selections").splice(objIndex + 1, this.options.length);

        var listIndex = _.findIndex(
          this.model.get("categoryOptions"),
          function (category) {
            return category.facet === facet;
          }
        );
        this.model.get("categoryOptions")[listIndex].options = [];
        this.model.get("categoryOptions")[listIndex].disabled = true;

        $nextSelect = $nextSelect.next("select");
      }
      this.model.set("selections", this.model.get("selections"));
    };

    this.events = {
      "change .find-pf-search-input": "changeOptionHandler",
      "click .find-pf-search-form-options-container button": "filterPLP",
    };

    // @ts-ignore
    // this.listenTo(this.model, 'change:category', function (newModel) {
    // 	// check if there is a change of category
    // 	this.render();
    // });

    this.filterPLP = function (e) {
      e.preventDefault();
      var $target = $(e.target);
      var form = $target.parents("form");

      var formValues = form.serialize();
      // 'custitembolt_pattern_mm=4x108&custitemrs_wheel_min_diameter=17'
      //
      if (formValues) {
        formValues = formValues.trim();
        this.options.forEach(function (option) {
          formValues = formValues.replace(
            new RegExp(option.facet, "g"),
            option.UrlComponent.trim()
          );
        });
        Backbone.history.navigate("search?" + formValues, { trigger: true });
      }
    };

    this.getContext = function () {
      var category = this.model.get("category").name;
      var changeCat =
        this.model.get("category") !== this.model._previousAttributes.category;
      var self = this;
      if (changeCat || !this.model.get("categoryOptions")) {
        this.model.unset("categoryOptions");
        var initialColumn = this.getOptions()[0].facet;
        var nextValue = this.getListValues(
          category,
          initialColumn,
          nextFacetColumn,
          false,
          true
        );
        nextValue
          .then(function (nextValues) {
            self.model.set("selections", []);
            self.model.set("step", 0);
            self.model.set("nextValue", nextValues);
            _.findWhere(self.model.get("nextValue"), { selected: true })
              ? (_.findWhere(self.model.get("nextValue"), {
                  selected: true,
                }).selected = false)
              : null;
            self.render();
          })
          .catch(function (error) {
            console.error("Error getting list values", error);
          });
      }

      if (!this.model.get("categoryOptions")) {
        self.options = self.getOptions();
        for (var i = 1; i < self.options.length; i++) {
          self.options[i].disabled = true;
        }
        this.model.set("categoryOptions", self.options);
      }
      var currentStep = this.model.get("step");
      var previousSelection = this.model.get("selections")[currentStep - 1];
      if (previousSelection && previousSelection.id) {
        var previousOptions = this.options[currentStep - 1].options;
        _.findWhere(previousOptions, { selected: true })
          ? (_.findWhere(previousOptions, { selected: true }).selected = false)
          : null;
        _.findWhere(previousOptions, { id: previousSelection.id })
          ? (_.findWhere(previousOptions, {
              id: previousSelection.id,
            }).selected = true)
          : null;
        this.options[currentStep].disabled = false;
        this.model.get("nextValue");
      }
      this.options[currentStep].options = this.model.get("nextValue");
      // SC.loadingIndicatorHide();
      return {
        options: this.options,
      };
    };
  }

  SDBFindPerfectFitSearchView.prototype = Object.create(SCView.prototype);
  SDBFindPerfectFitSearchView.prototype.constructor =
    SDBFindPerfectFitSearchView;

  SDBFindPerfectFitSearchView.prototype.contextDataRequest = ["miscData"];
  SDBFindPerfectFitSearchView.prototype.validateContextDataRequest =
    function () {
      return true;
    };

  SDBFindPerfectFitSearchView.prototype.getOptions = function () {
    try {
      var category = this.model.get("category")
        ? this.model.get("category").name
        : "Vehicle";
      return this.env.getConfig("SDBFindPerfectFit." + category) || [];
    } catch (error) {
      console.error("Error getting options", error);
    }
  };

  SDBFindPerfectFitSearchView.prototype.getListValues = function (
    category,
    currentSelection,
    nextFacet,
    async,
    initialRequest
  ) {
    try {
      var self = this;
      var compId = SC.ENVIRONMENT.companyId;
      var categoryName = self.model.get("category").name;
      var res = "";
      var requestType = async ? true : false;
      if (category !== "Wheels" && category !== "Tires")
        return jQuery
          .Deferred(function (deferred) {
            deferred.resolve([]);
          })
          .promise();
      if (initialRequest && self.model.get("initialData-" + categoryName))
        return jQuery
          .Deferred(function (deferred) {
            deferred.resolve(
              self.model.get("initialData-" + categoryName).values
            );
          })
          .promise();
      SC.loadingIndicatorShow();
      return jQuery
        .Deferred(function (deferred) {
          self.model
            .fetch({
              async: true,
              cache: true,
              AjaxRequestsKiller: AjaxRequestsKiller.getKillerId(),
              data: {
                category: category,
                initialRequest: initialRequest,
                selection: JSON.stringify(currentSelection),
                nextFacet: nextFacet,
              },
            })
            .done(function (response) {
              if (!response) {
                return;
              }
              var data = response.data ? response.data : {};
              res = data;
              if (initialRequest) {
                self.model.set("initialData-" + categoryName, {
                  category: categoryName,
                  values: data,
                });
              }
              if (requestType) {
                self.model.set("nextValue", data);
                self.render();
              }

              SC.loadingIndicatorHide();
              deferred.resolve(data);
            })
            .catch(function (error) {
              SC.loadingIndicatorHide();
              console.error("Error getting list values", error);
              deferred.reject(error);
            });
        })
        .promise();
    } catch (error) {
      console.log("Error getting list values", error);
    }
  };

  return SDBFindPerfectFitSearchView;
});
